import styled from 'styled-components'

export const FunctionSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .function-list-video {
    @media (min-width: 1100px) {
      display: flex;
    }
  }

  .desktop-video {
    display: none;

    @media (min-width: 1100px) {
      display: flex;
    }
  }

  .mobile-tablet-video {
    margin-top: 16px;
    max-width: 600px;

    @media (min-width: 600px) {
      max-width: 70%;
    }

    @media (min-width: 1100px) {
      display: none;
    }
  }
`

export const FunctionListWrapper = styled.div`
  padding: 0 16px;
  .list-icon {
  }

  .list-flex {
    display: flex;
    justify-content: center;
    @media (min-width: 1300px) {
      padding-top: 12px;
    }
    @media (min-width: 1400px) {
      padding-top: 20px;
    }
  }

  .text-wrapper {
    max-width: 423px;
    padding-left: 20px;
  }

  .button-spacer {
    @media (min-width: 1400px) {
      padding-top: 20px;
    }
  }
`
